<template>
  <el-dialog
    title="关联模型字段"
    :visible.sync="dialogVisible"
    width="70%"
    custom-class="associated-model-dialog"
    destroy-on-close
    :before-close="handleClose"
  >
    <div class="content">
      <ul>
        <li
          class="associated-item"
          v-for="(modelItem, modelIndex) in getModelJson"
          :key="modelIndex"
        >
          <div class="container">
            <div class="field-associated">
              <p class="title">
                <img src="@/assets/field-associated.png" alt="" />
                字段关联
              </p>
              <ul>
                <li v-for="(item, index) in modelItem.items" :key="index">
                  <span class="label">{{ item.formModelLabel }}</span>
                  <template v-if="index === 0">
                    <span class="text">关联</span>
                    <span class="label">
                      {{ modelItem.warehouseModelLabel }}
                    </span>
                    <span class="text">的</span>
                    <span class="label">
                      {{ item.warehouseModelLabel }}
                    </span>
                  </template>

                  <template v-if="index > 0">
                    <span class="text">由关联模型的</span>
                    <span class="label">
                      {{ item.warehouseModelLabel }}
                    </span>
                    <span class="text">自动填充</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="data-associated">
              <p class="title">
                <img src="@/assets/field-associated.png" alt="" />
                数据关联
              </p>
              <ul>
                <li>
                  <span class="label">{{ modelItem.warehouseModelLabel }}</span>
                  <span class="text">的</span>
                  <span class="label">{{ modelItem.matchItemLabel }}</span>
                  <span class="text">匹配</span>
                  <span class="label">{{ modelItem.matchSelectorLabel }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="handle">
            <div class="wrap">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(modelItem, modelIndex)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(modelIndex)"
              >
                删除
              </el-button>
            </div>
          </div>
        </li>
      </ul>
      <p class="button" @click="handleAdd">
        <i class="el-icon-plus"></i>
        添加
      </p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button plain @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>

    <EditModuleDialog
      :currentParams="currentParams"
      :list="list"
      :sonPages="sonPages"
      :visible.sync="editModuleVisible"
      :modelJson="getModelJson"
      @success="handleSuccess"
    />
  </el-dialog>
</template>
<script>
import EditModuleDialog from './EditModule.vue'
export default {
  props: {
    list: Array,
    sonPages: Object,
    visible: Boolean,
    modelJson: Array,
  },
  components: {
    EditModuleDialog,
  },
  data() {
    return {
      editModuleVisible: false,
      currentIndex: -1,
      currentParams: null,
      getModelJson: [],
    }
  },
  watch: {
    dialogVisible(value) {
      if (value) {
        this.getModelJson = JSON.parse(JSON.stringify(this.modelJson))
      }
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    // 添加
    handleAdd() {
      this.currentIndex = -1
      this.currentParams = null
      this.editModuleVisible = true
    },
    // 编辑
    handleEdit(item, index) {
      this.currentIndex = index
      this.currentParams = {
        ...item,
      }
      this.editModuleVisible = true
    },
    // 删除
    handleDelete(index) {
      this.getModelJson.splice(index, 1)
    },
    handleSuccess(form) {
      if (this.currentIndex >= 0) {
        // 编辑
        this.getModelJson[this.currentIndex] = JSON.parse(JSON.stringify(form))
        return
      }
      // 新增
      this.getModelJson.push({
        ...form,
      })
    },
    // 取消
    handleClose() {
      this.dialogVisible = false
    },
    // 确定
    handleSubmit() {
      this.$emit('success', this.getModelJson)
      this.dialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.associated-model-dialog) {
  p {
    margin: 0;
    padding: 0;
  }

  ul,
  li {
    list-style: none;
  }
  .el-dialog__header {
    padding: 10px 20px;
    background: #f8fafc;
    .el-dialog__title {
      font-size: 16px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: '';
        position: absolute;
        top: 3px;
        left: 0;
        width: 4px;
        height: 16px;
        background: #205cff;
        border-radius: 1px;
      }
    }

    .el-dialog__headerbtn {
      top: 13px;
    }
  }

  .el-dialog__body {
    // height: calc(80vh - 100px);
    // overflow: auto;
    padding: 25px;
    background: #f8fafc;

    .content {
      .associated-item {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #dcdcdc;
        padding: 10px;
        margin-bottom: 12px;
        position: relative;

        .container {
          width: calc(100% - 85px);
          .field-associated,
          .data-associated {
            .title {
              display: flex;
              align-items: center;
              font-size: 12px;
              margin-bottom: 15px;
              img {
                display: block;
                width: 14px;
                height: 14px;
                margin-right: 5px;
              }
            }

            ul {
              li {
                margin-bottom: 15px;
                height: 36px;
                align-items: center;
                display: flex;
                span {
                  margin-right: 10px;
                }
                .label {
                  display: inline-block;
                  height: 36px;
                  line-height: 36px;
                  width: 220px;
                  background: rgba(32, 92, 255, 0.08);
                  border-radius: 4px;
                  text-align: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding: 0 10px;
                }
              }
            }
          }
        }

        .handle {
          position: absolute;
          right: 0;
          top: 0;
          width: 85px;
          height: 100%;
          border-left: 1px solid #dcdcdc;
          .wrap {
            position: absolute;
            left: 0;
            right: 0;
            top: 0b;
            top: 0;
            bottom: 0;
            margin: auto;
            height: 60px;

            .el-button {
              margin: 0 auto !important;
              display: block;
            }
          }
        }
      }
      .button {
        cursor: pointer;
        color: #205cff;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        border: 1px solid #205cff;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 5px;
        }
      }
    }
  }

  .el-dialog__footer {
    border-top: 1px solid #ecf0f6;
    padding: 15px 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
